const isValidPhone = (value: string): boolean => {
  const numbers = value.replace(/\D/g, '');
  return numbers.length >= 10 && numbers.length <= 11;
};

export { isValidPhone };
